/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AccessPlanCouponUsageSummary } from './AccessPlanCouponUsageSummary';
import { CourseCouponUsageSummary } from './CourseCouponUsageSummary';
import { TenantCouponUsageSummary } from './TenantCouponUsageSummary';
const CouponGrantParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('coupon')],
    [
        'coupon',
        /* #__PURE__ */ parsers.taggedUnion('scope', [
            ['course', CourseCouponUsageSummary],
            ['tenant', TenantCouponUsageSummary],
            ['access-plan', AccessPlanCouponUsageSummary],
        ]),
    ],
]);
export class CouponGrant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CouponGrantParser.decode(input).map(res => new CouponGrant(res));
    }
    static unsafeDecode(input) {
        return CouponGrant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CouponGrantParser.encode(data);
    }
    static schema() {
        return CouponGrantParser.schema();
    }
}
